<template>
  <div data-track="Social Ads Creator - Image creator tab">
    <div style="top:-10000px;position:absolute" class="reposition-box" ref="previewCropperBox">
      <vue-cropper
        ref="previewCropper"
        :cropBoxMovable="false"
        dragMode="move"
        :cropBoxResizable="false"
        :background="false"
        :viewMode="1"
        :src="formVal.bgImage.url"
        :zoomable="false"
        :center="false"
        :guides="false"
        :toggleDragModeOnDblclick="false"
        @ready="fireUpCropper('previewCropper')"
      ></vue-cropper>
    </div>

    <div v-if="reposition.isModeOn">
      <div class="is-flex font-size-14 flex-align-baseline flex-justify-center text-default reposition-control-box">
        Zoom:
        <input-slider v-on:custom-slider-updated="changeZoomSlider" :showSteps="false" :labels="reposition.zoomSlider.labels"
                      :default-value="reposition.zoomSlider.default"/>
        <button
          class="button hollow-btn"
          data-track="Social Ads Creator - Image creator tab - Repositioning done"
          @click="completeReposition"
        >DONE
        </button>
      </div>
      <div class="reposition-box pos-relative" ref="reposBox">
        <vue-cropper
          ref="reposCropper"
          :cropBoxMovable="false"
          dragMode="move"
          :cropBoxResizable="false"
          :background="false"
          :viewMode="1"
          :src="formVal.bgImage.url"
          :zoomable="false"
          :center="false"
          :guides="false"
          :toggleDragModeOnDblclick="false"
          @ready="fireUpCropper('reposCropper')"
        ></vue-cropper>
        <div :style="{'top':previewBox.starPos.y+reposition.cropbox.y+'px', 'left':previewBox.starPos.x+reposition.cropbox.x+'px'}"
             class="is-absolute is-flex flex-align-centre">
          <rating
            :useFa="true"
            :stars="reviewForPreview.rating"
            :style="{'--starColor':formVal.starColor, '--starSize': `${starRating.fontSize/previewRatio}px`, '--starSpacing':`${starRating.spacing/previewRatio}px`}"
            class="cropper-content-rating"
          ></rating>
          <div :style="{'color':formVal.fontColor, 'font-size': `${author.fontSize/previewRatio}px`, 'margin-left': `${author.marginLeft/previewRatio}px`}">
            - {{ reviewForPreview.author }}
          </div>
        </div>
        <img v-if="formVal.bizLogo.url" :src="formVal.bizLogo.url"
             :style="{'width':formVal.bizLogo.width/previewRatio+'px', 'top':previewBox.logoPos.y+reposition.cropbox.y+'px', 'left':previewBox.logoPos.x+reposition.cropbox.x+'px'}"
             class="is-absolute"/>
        <div
          :style="{'width':channels[this.formVal.channel].reviewBox.width/previewRatio+'px', 'top':previewBox.reviewTextPos.y+reposition.cropbox.y+'px', 'left':previewBox.reviewTextPos.x+reposition.cropbox.x+'px', 'color':formVal.fontColor, 'font-size': formVal.fontSize/previewRatio+'px', 'text-align':formVal.textAlign, 'max-height':channels[this.formVal.channel].reviewBox.height/previewRatio+'px', 'line-height': reviewLineHeight[formVal.fontSize]/previewRatio+'px'}"
          class="is-absolute is-clipped">
          <span class="revalia">“</span>{{ reviewForPreview.body }}<span class="revalia">”</span>
        </div>
        <div class="is-absolute"
             :style="{'left': (footer.marginX/previewRatio)+reposition.cropbox.x+'px', 'right': footer.marginX/previewRatio+'px', 'top': previewBox.footer.yPos+reposition.cropbox.y+'px', 'width': previewBox.footer.width+'px'}">
          <hr class="ad-preview-footer_divider" v-if="formVal.showMetrics"/>
          <div class="level" :style="{'margin-top': channels[this.formVal.channel].hpLogo.marginTop/previewRatio+'px'}">
            <div class="level-left" :style="{'color':formVal.fontColor, 'font-size': channels[this.formVal.channel].metricsFontSize/previewRatio+'px'}">
              <template v-if="formVal.showMetrics">
                Rated&nbsp;
                <span class="has-text-weight-bold">{{ reviewRatingAvg }} / 5</span>
                &nbsp;|&nbsp;
                <span class="has-text-weight-bold">{{ totalReviews }}</span>&nbsp;
                Reviews
              </template>
            </div>
            <div class="level-right">
              <img :src="`/static/img/ads/${formVal.logo}`"
                   :style="{'width': channels[this.formVal.channel].hpLogo.width/previewRatio+'px', 'height': channels[this.formVal.channel].hpLogo.height/previewRatio+'px'}"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <div v-if="isPaidUser" style="top:-10000px;position:absolute">
        <div ref="adHtml" class="pos-relative" :key="previewBox.key"
             :style="{'width': channels[this.formVal.channel].width+'px', 'height': channels[this.formVal.channel].height+'px'}">
          <div :style="{'top':starYPos+'px', 'left':starXPos+'px'}" class="drag-elem is-flex flex-align-centre">
            <rating
              :useFa="true"
              :stars="reviewForPreview.rating"
              :style="{'--starColor':formVal.starColor, '--starSize': `${starRating.fontSize}px`, '--starSpacing':`${starRating.spacing}px`}"
              class="cropper-content-rating"
            ></rating>
            <div :style="{'color':formVal.fontColor, 'font-size': `${author.fontSize}px`, 'margin-left': `${author.marginLeft}px`}">
              - {{ reviewForPreview.author }}
            </div>
          </div>
          <img v-if="formVal.bizLogo.url" :src="formVal.bizLogo.dataUri" :style="{'width':formVal.bizLogo.width+'px', 'top':logoYPos+'px', 'left':logoXPos+'px'}"
               class="drag-elem"/>
          <div class="drag-elem is-clipped"
               data-height-fix="true"
               :style="{'width':channels[this.formVal.channel].reviewBox.width+'px', 'top':reviewTextYPos+'px', 'left':reviewTextXPos+'px', 'color':formVal.fontColor, 'font-size': formVal.fontSize+'px', 'text-align':formVal.textAlign, 'max-height':channels[this.formVal.channel].reviewBox.height+'px', 'line-height': reviewLineHeight[formVal.fontSize]+'px'}">
            <span class="revalia">“</span>{{ reviewForPreview.body }}<span class="revalia">”</span>
          </div>
          <img :src="adCroppedUri" :style="{'filter': `brightness(${100 - formVal.fillOpacity}%)`}"/>
          <div class="is-absolute" :style="{'left': footer.marginX+'px', 'right': footer.marginX+'px', 'bottom': footer.marginBottom+'px'}">
            <hr class="ad-preview-footer_divider" v-if="formVal.showMetrics"/>
            <div class="level" :style="{'margin-top': channels[this.formVal.channel].hpLogo.marginTop+'px'}">
              <div class="level-left" :style="{'color':formVal.fontColor, 'font-size': channels[this.formVal.channel].metricsFontSize+'px'}">
                <template v-if="formVal.showMetrics">
                  <span class="margin-right-8">Rated</span>
                  <span class="has-text-weight-bold margin-right-8">{{ reviewRatingAvg }} / 5</span>
                  <span class="margin-right-8">|</span>
                  <span class="has-text-weight-bold margin-right-12">{{ totalReviews }}</span>
                  Reviews
                </template>
              </div>
              <div class="level-right">
                <img :src="`/static/img/ads/${formVal.logo}`"
                     :style="{'width': channels[this.formVal.channel].hpLogo.width+'px', 'height': channels[this.formVal.channel].hpLogo.height+'px'}"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="is-flex has-spinner">
          <img
            class="has-spinner__spinner"
            src="/static/img/spinner.svg"
            v-if="isSaving"
          />
          <template v-else>
            <div class="file-mobile">
              <div class="head">
                <div class="level-left">
                  Easily turn your reviews into beautiful Social Ads for Instagram, Facebook and Twitter - no design skills
                  needed.
                </div>
              </div>

              <div class="form-box">
                <div class="sectionn margin-bottom-24">
                  <p class="section__head">Choose Your Channel</p>
                  <hr class="section_divider"/>
                  <div class="margin-bottom-9">Select the channel and size you want to push your review to.</div>
                  <div>
                    <img v-for="(channel, index) in channelDdOpts" :data-track="`Social Ads Creator - Image creator tab - ${channel.label} channel`" class="pointer"
                         :class="{'margin-left-20':index}" @click="chooseChannel(channel.key)"
                         :src="`/static/img/ads/${channel.imgName}${(formVal.channel === channel.key)?'_sel':''}.png`">
                  </div>
                </div>

                <template v-if="isPaidUser">
                  <div class="sectionn margin-bottom-24">
                    <p class="section__head">Background image</p>
                    <hr class="section_divider"/>
                    <div>Upload your own image or select an image from our range of existing images.</div>

                    <div class="photo-row">
                      <img class="photo-row-img" src="/static/img/review_images/camera.svg"/>
                      <a class="blue-link font-size-12"
                         data-track="Social Ads Creator - Image creator tab - Background image change link" href="#"
                         @click.prevent="openBgModal">Add image</a>
                    </div>
                  </div>

                  <div class="sectionn review-section">
                    <div class="level margin-bottom-0">
                      <div class="level-left section__head">Review</div>
                      <a
                        v-if="formVal.review.body"
                        class="level-right blue-link"
                        data-track="Social Ads Creator - Image creator tab - Review change link"
                        href="#"
                        @click.prevent="openReviewModal"
                      >Choose another review</a>
                    </div>

                    <hr class="section_divider"/>
                    <div>Select the part of the review you would like to share.</div>

                    <div class="review-box">
                      <div class="review-box-inner">
                        <template v-if="formVal.review.body">
                          <div class="is-flex">
                            <rating :stars="formVal.review.rating" class="font-size-9 star-rating"></rating>
                            <span class="pad-top-1">By {{ formVal.review.author }}</span>
                          </div>
                          <div
                            class="review-text"
                            v-on:mouseup="selectReviewText"
                            v-on:onselectionchange="selectReviewText"
                          >{{ formVal.review.body }}
                          </div>
                        </template>
                        <a
                          v-else
                          class="blue-link"
                          data-track="Social Ads Creator - Image creator tab - Select review link"
                          href="#"
                          @click.prevent="openReviewModal"
                        >Select your review</a>
                      </div>
                    </div>

                    <div class="is-flex margin-bottom-18">
                      <div class="margin-right-50">
                        <div class="margin-bottom-10">Font colour</div>
                        <div class="field is-flex flex-align-centre">
                          <div class="verte-container">
                            <verte v-model="formVal.fontColor" :showHistory="false" model="hex"></verte>
                          </div>
                          <label class="font-size-11 is-uppercase">{{ formVal.fontColor }}</label>
                        </div>
                      </div>
                      <div>
                        <div class="margin-bottom-4">Font size</div>
                        <custom-dropdown
                          :options="fontSizeDdOpts"
                          class="font-size-dd"
                          group="adsCreatorFontSize"
                        />
                      </div>
                      <div
                        class="has-text-centered margin-right-40 pointer"
                        @click="setCropperContentAlign('left')"
                      >
                        <img
                          :class="{'align--selected':formVal.textAlign == 'left'}"
                          class="margin-bottom-4"
                          src="/static/img/ads/left_align.svg"
                        />
                        <br/>Left align
                      </div>
                      <div
                        class="has-text-centered margin-right-35 pointer"
                        @click="setCropperContentAlign('center')"
                      >
                        <img
                          :class="{'align--selected':formVal.textAlign == 'center'}"
                          class="margin-bottom-4"
                          src="/static/img/ads/center_align.svg"
                        />
                        <br/>Center
                      </div>
                      <div class="has-text-centered pointer" @click="setCropperContentAlign('right')">
                        <img
                          :class="{'align--selected':formVal.textAlign == 'right'}"
                          class="margin-bottom-4"
                          src="/static/img/ads/right_align.svg"
                        />
                        <br/>Right align
                      </div>
                    </div>

                    <div class="margin-bottom-10">Star rating colour</div>
                    <div class="field is-flex flex-align-centre">
                      <div class="verte-container">
                        <verte v-model="formVal.starColor" :showHistory="false" model="hex"></verte>
                      </div>
                      <label class="is-uppercase">{{ formVal.starColor }}</label>
                      <rating
                        :useFa="true"
                        :stars="3"
                        :style="{'--starColor':formVal.starColor}"
                        class="font-size-9 star-rating-color"
                      ></rating>
                    </div>
                  </div>

                  <div class="sectionn margin-bottom-10">
                    <p class="section__head">Style</p>
                    <hr class="section_divider"/>
                    <div class="section__light-text">Customise the display of your Review.</div>
                    <div class="is-flex margin-bottom-18">
                      <div>
                        <div class="margin-bottom-15">Filter Contrast</div>
                        <div class="is-flex">
                          <div>
                            <div class="filter-contrast-box" :class="{'filter-contrast-box--sel': formVal.fillOpacity === 0}" @click="chooseFilter(0)">
                              <div></div>
                            </div>
                            <div>No Filter</div>
                          </div>
                          <div class="margin-left-16 margin-right-13">
                            <div class="filter-contrast-box filter-contrast-box--light" :class="{'filter-contrast-box--sel': formVal.fillOpacity === 25}"
                                 @click="chooseFilter(25)">
                              <div></div>
                            </div>
                            <div>Light Filter</div>
                          </div>
                          <div>
                            <div class="filter-contrast-box filter-contrast-box--dark" :class="{'filter-contrast-box--sel': formVal.fillOpacity === 50}"
                                 @click="chooseFilter(50)">
                              <div></div>
                            </div>
                            <div>Dark Filter</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="is-flex addBizLogoSec">
                      <add-logo :show-default-logo="false" :logoPath="formVal.bizLogo.url" :onClick="openImageLibraryModal" :onRemove="unselectBizLogo">
                        <template slot="label">
                          Add your logo
                        </template>
                      </add-logo>
                      <div class="has-spinner" v-if="formVal.bizLogo.url">
                        <img
                          v-if="bizLogoSlider.isLoading"
                          class="has-spinner__spinner"
                          src="/static/img/spinner.svg"
                        />
                        <div class="is-flex font-size-14 flex-align-baseline" v-else>
                          Size:
                          <input-slider class="bizlogoWidthSlider" v-on:custom-slider-updated="changeBizLogoSlider" :showSteps="false" :labels="bizLogoSlider.labels"
                                        :default-value="bizLogoSlider.default"/>
                          {{ formVal.bizLogo.width }} px
                        </div>
                      </div>
                    </div>

                    <div class="margin-top-20">Include my metrics</div>
                    <div class="is-flex margin-top-8">
                      <div class="field margin-right-25">
                        <input
                          id="metricsYes"
                          v-model="formVal.showMetrics"
                          :value="true"
                          class="margin-right-7"
                          name="metrics"
                          type="radio"
                        />
                        <label class="font-size-11" for="metricsYes">Yes</label>
                      </div>

                      <div class="field">
                        <input
                          id="metricsNo"
                          v-model="formVal.showMetrics"
                          :value="false"
                          class="margin-right-7"
                          name="metrics"
                          type="radio"
                        />
                        <label class="font-size-11" for="metricsNo">No</label>
                      </div>
                    </div>

                    <div class="margin-top-8">Logo</div>
                    <div class="is-flex margin-top-8">
                      <div class="field margin-right-20">
                        <input
                          id="logo1"
                          v-model="formVal.logo"
                          name="logo"
                          type="radio"
                          value="logo-transparent.svg"
                        />
                        <label class="margin-left--8" for="logo1">
                          <img class="valign-middle" src="/static/img/logo-transparent.svg"/>
                        </label>
                      </div>

                      <div class="field">
                        <input
                          id="logo4"
                          v-model="formVal.logo"
                          class="margin-right-7"
                          name="logo"
                          type="radio"
                          value="logo-white.svg"
                        />
                        <label for="logo4">
                          <img class="valign-middle grey-bg" src="/static/img/logo-white.svg"/>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="modal is-active modal-new" id="bgModal" v-if="bgModal.show">
                    <div class="modal-background"></div>
                    <div class="modal-card">
                      <header class="modal-card-head">
                        <a class="modal-close-link" href="#" @click.prevent="closeBgModal">
                          <img src="/static/img/ads/modal_close.svg"/>
                        </a>
                      </header>

                      <section class="modal-card-body">
                        <custom-tabs-js
                          :tabs="[{'label':'Standard images', 'track':'Social Ads Creator - Image creator tab - Standard images tab', 'active': true, 'id':'standard'}, {'label':'Your images', 'track':'Social Ads Creator - Image creator tab - Your images tab', 'id':'uploaded'}]"
                          group="adsLibraryBgPopup"
                        >
                          <template slot="standard">
                            <div class="has-spinner">
                              <img
                                v-if="bgModal.standard.isLoading"
                                class="has-spinner__spinner"
                                src="/static/img/spinner.svg"
                              />
                              <div
                                v-else-if="bgModal.standard.listData.length"
                                ref="standardBgList"
                                class="thumbnail-container-standard"
                                v-on:scroll="handleStandardScroll"
                              >
                        <span
                          v-for="(image, index) in bgModal.standard.listData"
                          :key="index"
                          :class="{'thumbnail--selected': bgModal.selected.url == image}"
                          class="thumbnail"
                          @click="selectBg(image)"
                        >
                          <div class="frame"></div>
                          <img :src="`/static/img/ads/standard_bg/${image}`"/>
                        </span>
                              </div>
                            </div>
                          </template>
                          <template slot="uploaded">
                            <div class="has-spinner">
                              <img
                                v-if="bgModal.custom.isLoading"
                                class="has-spinner__spinner"
                                src="/static/img/spinner.svg"
                              />
                              <template v-else>
                                <alert-message type="info" class="margin-bottom-15 margin-left-51 margin-right-21">
                                  Only upload content that you own and are licensed to use. Upload a PNG or JPG file. Minimum file size 200KB and Max 10MB
                                </alert-message>
                                <div v-if="bgModal.custom.isUploading" class="has-spinner dropzone-box">
                                  <img class="has-spinner__spinner" src="/static/img/spinner.svg"/>
                                </div>
                                <vue-dropzone
                                  v-else
                                  id="dropzone"
                                  :options="bgModal.custom.dropzoneOptions"
                                  :useCustomSlot="true"
                                  class="dropzone-box"
                                  data-track="Social Ads Creator - Image creator tab - Background image upload"
                                  @vdropzone-file-added="uploadImage"
                                >
                                  <img src="/static/img/ads/dropzone.png"/>
                                  <p>
                                    Drop your image here, or
                                    <a class="blue-link">select a image</a>
                                  </p>
                                </vue-dropzone>
                                <div
                                  v-if="bgModal.custom.listData.length"
                                  ref="uploadedBgList"
                                  class="thumbnail-container-custom"
                                  v-on:scroll="handleUploadedScroll"
                                >
                          <span
                            v-for="(image, index) in bgModal.custom.listData"
                            :key="index"
                            :class="{'thumbnail--selected': bgModal.selected.url == image.image, 'thumbnail--disabled': areDimensionsLess(image.width, image.height)}"
                            class="thumbnail"
                            @click="selectBg(image, index)"
                          >
                            <div class="frame"></div>
                            <img :src="image.image_thumb"/>
                            <div class="thumbnail-caption">{{ image.width }} x {{ image.height }}</div>
                          </span>
                                </div>
                              </template>
                            </div>
                          </template>
                        </custom-tabs-js>
                      </section>

                      <footer>
                        <button
                          v-if="!bgModal.disableDelete"
                          :disabled="!bgModal.selected.id"
                          class="button hollow-btn"
                          data-track="Social Ads Creator - Image creator tab - Delete background Image"
                          @click="deleteBg"
                        >
                          DELETE IMAGE
                        </button>
                        <button
                          :disabled="!bgModal.selected.url"
                          class="button solid-btn"
                          data-track="Social Ads Creator - Image creator tab - Use background Image"
                          @click="useBg"
                        >USE IMAGE
                        </button>
                      </footer>
                    </div>
                  </div>

                  <div class="modal is-active modal-new" v-if="reviewModal.show">
                    <div class="modal-background"></div>
                    <div class="modal-card">
                      <header class="modal-card-head">
                        <a class="modal-close-link" href="#" @click.prevent="closeReviewModal">
                          <img src="/static/img/ads/modal_close.svg"/>
                        </a>
                        <div
                          class="modal-card-head-title"
                        >Select the review you want to use for your Social Ad
                        </div>
                        <div class="level">
                          <div class="field review-filter-input level-left">
                            <p class="control has-icons-left">
                              <input
                                v-model="reviewModal.filter.keyword"
                                class="input"
                                placeholder="Search review"
                                type="text"
                              />
                              <span class="icon is-small is-left">
                                <i class="fas fa-search"></i>
                              </span>
                            </p>
                          </div>
                          <div class="level-right">
                            <date-select-filter
                              :filter_items="reviewModal.filter.dateFilter.props"
                              :styleProp="reviewModal.filter.dateFilter.styleProp"
                              class="custom-dropdown custom-dropdown--small padding-top-0 padding-right-0 margin-right-20"
                              @onDateChange="handleReviewDateChange"
                            />
                            <!-- Star Filter Beg you guys available for the schedins -->
                            <star-rating-filter
                              class="rating-dropdown custom-dropdown"
                              data-track="Social Ads Creator - Image creator tab - Review star rating filter change"
                              @onRatingFilterChange="handleReviewRatingChange"
                            ></star-rating-filter>
                            <!-- Star Filter Ends -->
                          </div>
                        </div>
                      </header>

                      <section class="modal-card-body">
                        <div class="has-spinner">
                          <img
                            v-if="reviewModal.isLoading"
                            class="has-spinner__spinner"
                            src="/static/img/spinner.svg"
                          />
                          <template v-else>
                            <div v-if="!reviewModal.listData.length" class="reviews-warning">
                              <alert-message
                                type="warning"
                              >You need a minimum of one review to create a Social Ad
                              </alert-message>
                            </div>

                            <div
                              v-else
                              ref="reviewList"
                              :style="{height:`${reviewModal.listElemHeight}px`}"
                              class="reviews-block"
                              v-on:scroll="handleReviewsScroll"
                            >
                              <div
                                v-for="(review, index) in reviewModal.listData"
                                :key="index"
                                class="review-row"
                                data-track="Social Ads Creator - Image creator tab - Review select"
                                @click="chooseReview(review._source)"
                              >
                                <div class="level margin-bottom-2">
                                  <rating
                                    :stars="review._source.rating"
                                    class="font-size-9 level-left star-rating-review"
                                  ></rating>
                                  <span class="level-right silver-text">{{ review._source.authorDisplayName }}</span>
                                </div>
                                <div class="level margin-bottom-12 flex-align-start">
                                  <div class="level-left has-text-weight-bold f14 w89">{{ review._source.review_title }}</div>
                                  <span
                                    class="level-right silver-text"
                                  >{{ review._source.created_at | formattedDateAndTime }}</span>
                                </div>
                                <div class="f12 pos-relative">
                                  <template v-if="isLongReview(review._source.review_body)">
                            <span
                              :class="{'review-body-hide':(!('showFull' in review) || !review.showFull)}"
                              class="review-body"
                            >
                              {{ review._source.review_body }}
                              <a
                                class="blue-link"
                                href="#"
                                @click.prevent.stop="hideFullReview(review)"
                              >Show less</a>
                            </span>
                                    <span
                                      v-if="(!('showFull' in review) || !review.showFull)"
                                      class="ellipses"
                                    >
                              …
                              <a
                                class="blue-link"
                                href="#"
                                @click.prevent.stop="showFullReview(review)"
                              >Show more</a>
                            </span>
                                  </template>
                                  <template v-else>{{ review._source.review_body }}</template>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </section>
                    </div>
                  </div>

                  <hr class="section_divider margin-bottom-20"/>
                </template>
                <div v-else class="upgrade-box">
                  <div class="upgrade-box__header">
                    Social Ad customisation
                    <img align="right" src="/static/img/ads/lock.svg"/>
                  </div>
                  <div class="upgrade-box__main">
                    <a class="blue-link" href="/billing/edit-plan/g1/monthly">Upgrade</a> your Plan and
                    start turning your reviews into beautifully designed social proof Ads.
                  </div>
                </div>

                <div class="is-flex flex-justify-end margin-bottom-150">
                  <button
                    :disabled="!isPaidUser || !formVal.review.selectedBody || isSaving"
                    class="button hollow-btn"
                    data-track="Social Ads Creator - Image creator tab - Save to library"
                    @click="saveToLibrary(null)"
                  >SAVE TO LIBRARY
                  </button>
                  <custom-dropdown
                    v-if="formVal.channel === 'fb_feed'"
                    :disabled="!isPaidUser || !formVal.review.selectedBody || isSaving"
                    :options="actionDdOpts"
                    class="action-dd"
                    group="adsCreatorAction"
                  />
                  <button
                    v-else
                    :disabled="!isPaidUser || !formVal.review.selectedBody || isSaving"
                    class="button solid-btn margin-left-15 font-size-12"
                    data-track="Social Ads Creator - Image creator tab - Download"
                    @click="saveAndDownloadAd"
                  >DOWNLOAD
                  </button>
                </div>
              </div>
            </div>
            <div class="preview-col">
              <alert-message v-if="!formVal.review.selectedBody" type="info">
                The below image is
                <span
                  class="has-text-weight-bold"
                >an example for demonstration purpose only.</span>
              </alert-message>
              <div class="preview-box">
                <div class="preview-box-head level">
                  <div class="level-left">Preview</div>
                  <a v-if="isPaidUser" class="level-right" data-track="Social Ads Creator - Image creator tab - Reposition link" @click="openRepositionMode">
                    <img src="/static/img/ads/reposition.svg"/>
                    Reposition
                  </a>
                </div>
                <div class="preview-box-main">
                  <div class="pos-relative" ref="previewBox" :style="{'height': `${previewBoxHeight}px`}" :key="previewBox.key">
                    <vue-draggable-resizable :resizable="false" :onDrag="onDragStar" :y="previewBox.starPos.y" :x="previewBox.starPos.x" w="auto"
                                             h="auto" :parent="true"
                                             class="drag-elem is-flex flex-align-centre drag-elem-highlight">
                      <rating
                        :useFa="true"
                        :stars="reviewForPreview.rating"
                        :style="{'--starColor':formVal.starColor, '--starSize': `${starRating.fontSize/previewRatio}px`, '--starSpacing':`${starRating.spacing/previewRatio}px`}"
                        class="cropper-content-rating"
                      ></rating>
                      <div
                        :style="{'color':formVal.fontColor, 'font-size': `${author.fontSize/previewRatio}px`, 'margin-left': `${author.marginLeft/previewRatio}px`}">
                        - {{ reviewForPreview.author }}
                      </div>
                    </vue-draggable-resizable>
                    <vue-draggable-resizable v-if="formVal.bizLogo.url" :resizable="false" :w="formVal.bizLogo.width/previewRatio" h="auto" :onDrag="onDragLogo"
                                             :y="previewBox.logoPos.y" :x="previewBox.logoPos.x" :parent="true"
                                             class="drag-elem drag-elem-highlight">
                      <img :src="formVal.bizLogo.url">
                    </vue-draggable-resizable>
                    <vue-draggable-resizable :resizable="false" :onDrag="onDragReview" :y="previewBox.reviewTextPos.y" :x="previewBox.reviewTextPos.x"
                                             :w="channels[this.formVal.channel].reviewBox.width/previewRatio" h="auto" :parent="true"
                                             class="drag-elem is-clipped drag-elem-highlight"
                                             :style="{'color':formVal.fontColor, 'font-size': formVal.fontSize/previewRatio+'px', 'text-align':formVal.textAlign, 'max-height':channels[this.formVal.channel].reviewBox.height/previewRatio+'px', 'line-height': reviewLineHeight[formVal.fontSize]/previewRatio+'px'}">
                      <span class="revalia">“</span>{{ reviewForPreview.body }}<span class="revalia">”</span>
                    </vue-draggable-resizable>
                    <img :src="previewBox.croppedUri" :style="{'filter': `brightness(${100 - formVal.fillOpacity}%)`}"/>
                    <div class="is-absolute" ref="previewFooter"
                         :style="{'left': footer.marginX/previewRatio+'px', 'right': footer.marginX/previewRatio+'px', 'bottom': footer.marginBottom/previewRatio+'px'}">
                      <hr class="ad-preview-footer_divider" v-if="formVal.showMetrics"/>
                      <div class="level" :style="{'margin-top': channels[this.formVal.channel].hpLogo.marginTop/previewRatio+'px'}">
                        <div class="level-left" :style="{'color':formVal.fontColor, 'font-size': channels[this.formVal.channel].metricsFontSize/previewRatio+'px'}">
                          <template v-if="formVal.showMetrics">
                            Rated&nbsp;
                            <span class="has-text-weight-bold">{{ reviewRatingAvg }} / 5</span>
                            &nbsp;|&nbsp;
                            <span class="has-text-weight-bold">{{ totalReviews }}</span>&nbsp;
                            Reviews
                          </template>
                        </div>
                        <div class="level-right">
                          <img :src="`/static/img/ads/${formVal.logo}`"
                               :style="{'width': channels[this.formVal.channel].hpLogo.width/previewRatio+'px', 'height': channels[this.formVal.channel].hpLogo.height/previewRatio+'px'}"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

      <ImageLibraryModal
        v-if="imageLibraryModal.show"
        :showTabs="['logoImage']"
        chosenTab="logoImage"
        @closeModal="closeImageLibraryModal"
        @imageSelected="handleBizLogoChosen"
      ></ImageLibraryModal>
    </template>
  </div>
</template>

<script>
/* eslint-disable no-new,no-undef,import/prefer-default-export */
import {AddLogo, AlertMessage, CustomDropdown, CustomTabsJs, DateSelectFilter, ImageLibraryModal, InputSlider, StarRatingFilter} from '@/components'
import Rating from '@/components/Rating'
import verte from 'verte'
import 'verte/dist/verte.css'
import {misc} from '@/mixins'
import axios from 'axios'
import moment from 'moment'
import vue2Dropzone from 'vue2-dropzone'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import localMixin from './mixin.js'
import {TooltipNew} from '@/widgets'
import VueDraggableResizable from 'vue-draggable-resizable'

export default {
  name: 'AdsCreator',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Ads Creator'
  },
  components: {
    StarRatingFilter,
    DateSelectFilter,
    CustomDropdown,
    Rating,
    verte,
    AlertMessage,
    CustomTabsJs,
    vueDropzone: vue2Dropzone,
    VueCropper,
    TooltipNew,
    AddLogo,
    ImageLibraryModal,
    InputSlider,
    VueDraggableResizable
  },
  mixins: [misc, localMixin],
  data () {
    return {
      /** Start: Dropdown options */
      channelDdOpts: [
        {
          label: 'Facebook',
          key: 'fb_feed',
          imgName: 'fb_channel'
        },
        {
          label: 'Instagram',
          key: 'inst_post',
          imgName: 'insta_channel'
        },
        {
          label: 'Twitter',
          key: 'twitter',
          imgName: 'twitter_channel'
        },
        {
          label: 'Linkedin',
          key: 'linkedin',
          imgName: 'linkedin_channel'
        }
      ],
      fontSizeDdOpts: [
        {
          label: '18 pt',
          value: 24
        },
        {
          label: '20 pt',
          value: 27,
          selected: true
        },
        {
          label: '22 pt',
          value: 29
        },
        {
          label: '24 pt',
          value: 32
        },
        {
          label: '26 pt',
          value: 35
        },
        {
          label: '28 pt',
          value: 37
        },
        {
          label: '36 pt',
          value: 48
        },
        {
          label: '48 pt',
          value: 64
        },
        {
          label: '72 pt',
          value: 96
        }
      ],
      actionDdOpts: [
        {
          label: 'PUBLISH',
          value: 'publish',
          selected: true,
          attr: {'data-track': 'Social Ads Creator - Image creator tab - Publish'}
        },
        {
          label: 'DOWNLOAD',
          value: 'download',
          attr: {'data-track': 'Social Ads Creator - Image creator tab - Download'}
        }
      ],
      /** End: Dropdown options */

      /** Start: Dimensions for Final Ad */
      channels: {
        fb_feed: {
          width: 1200,
          height: 628,
          reviewBox: {
            width: 600,
            height: 315
          },
          hpLogo: {
            width: 200,
            height: 49,
            marginTop: 21
          },
          metricsFontSize: 30
        },
        inst_post: {
          width: 1080,
          height: 1080,
          reviewBox: {
            width: 550,
            height: 550
          },
          hpLogo: {
            width: 230,
            height: 56,
            marginTop: 21
          },
          metricsFontSize: 30
        },
        twitter: {
          width: 1024,
          height: 512,
          reviewBox: {
            width: 512,
            height: 206
          },
          hpLogo: {
            width: 180,
            height: 44,
            marginTop: 21
          },
          metricsFontSize: 25
        },
        linkedin: {
          width: 1200,
          height: 628,
          reviewBox: {
            width: 600,
            height: 312
          },
          hpLogo: {
            width: 200,
            height: 49,
            marginTop: 21
          },
          metricsFontSize: 30
        }
      },
      reviewBox: {
        posX: 300,
        posY: 150
      },
      reviewLineHeight: {
        '24': 37,
        '27': 45,
        '29': 45,
        '32': 45,
        '35': 59,
        '37': 59,
        '48': 69,
        '64': 80,
        '96': 136
      },
      starRating: {
        fontSize: 40,
        spacing: 5,
        posX: 415,
        posY: 200
      },
      author: {
        fontSize: 19,
        marginLeft: 13
      },
      footer: {
        marginX: 34,
        marginBottom: 26
      },
      adCroppedUri: '',
      /** End: Dimensions for Final Ad */

      /** Start: Modal */
      bgModal: {
        standard: {
          filter: {
            page: {
              current: 0,
              total: 1
            }
          },
          allData: [],
          listData: [],
          isLoading: false,
          lockScroll: false
        },
        custom: {
          dropzoneOptions: {
            url: 'https://httpbin.org/post',
            maxFiles: 1,
            acceptedFiles: 'image/png, image/jpeg',
            previewsContainer: false,
            autoProcessQueue: false
          },
          filter: {
            page: {
              current: 0,
              total: 1
            }
          },
          listData: [],
          isLoading: false,
          lockScroll: false,
          isUploading: false
        },
        disableDelete: true,
        show: false,
        selected: {
          id: 0,
          url: './1_simon-migaj-Yui5vfKHuzs-unsplash_thumb.png',
          index: 0,
          width: 0,
          height: 0
        }
      },
      reviewModal: {
        filter: {
          dateFilter: {
            label: 'last_6_months',
            endDate: null,
            startDate: null,
            styleProp: {},
            props: [
              {
                name: 'date',
                label: 'Date',
                showApplyBtn: true,
                dataTrack: 'data-track="Social Ads Creator - Image creator tab - Review date filter change',
                default: {
                  type: 'months',
                  value: 6,
                  selected: 'Last 6 months'
                }, // moment.js placeholder in type
                disabled: [],
                elements: [
                  'Last 7 days',
                  'Previous month',
                  'Last 6 months',
                  'Last 12 months',
                  'Custom'
                ]
              }
            ]
          },
          starRating: [],
          keyword: '',
          page: {
            current: 0,
            total: 1,
            perPage: 7
          }
        },
        lockScroll: false,
        show: false,
        isLoading: false,
        listData: [],
        listElemHeight: 0
      },
      pageLeaveModal: {
        title: 'Are you sure?',
        body: 'You have unsaved changes on this page. If you navigate away, your changes will be lost. ',
        btn_action_title: 'STAY ON THIS PAGE',
        secondary_btn_title: 'LEAVE PAGE',
        to_path: '',
        show_btns: true,
        task: 'pageLeave'
      },
      imageLibraryModal: {
        show: false
      },
      reposition: {
        isModeOn: false,
        zoomSlider: {
          default: '0',
          prevVal: '',
          labels: [
            {
              label: '0',
              value: 0
            }
          ]
        },
        canvasRatio: 0,
        cropbox: {
          x: 0,
          y: 0
        },
        cropCanvas: {
          prevVal: {
            x: '',
            y: ''
          }
        }
      },
      previewBox: {
        width: 0,
        croppedUri: '',
        key: 0,
        reviewTextPos: {
          x: 0,
          y: 0
        },
        starPos: {
          x: 0,
          y: 0
        },
        logoPos: {
          x: 0,
          y: 0
        },
        footer: {
          yPos: 0,
          width: 0
        }
      },
      /** End: Modal */

      /** Start: Form related */
      formVal: {
        channel: 'fb_feed',
        review: {
          author: '',
          body: '',
          rating: 0,
          selectedBody: ''
        },
        bgImage: {
          url: '/static/img/ads/standard_bg/./1_simon-migaj-Yui5vfKHuzs-unsplash.jpg',
          width: 0,
          height: 0
        },
        fontColor: '#ffffff',
        fontSize: 20,
        textAlign: 'center',
        fillOpacity: 50,
        starColor: '#fbc64e',
        bizLogo: {
          url: '',
          width: 0,
          dataUri: ''
        },
        showMetrics: true,
        logo: 'logo-white.svg'
      },
      isFormChanged: false,
      /** End: Form related */

      isSaving: false,
      reviewRatingAvg: parseFloat(localStorage.reviewRatingAvg).toFixed(2),
      totalReviews: localStorage.totalReviews,
      bizLogoSlider: {
        isLoading: false,
        default: '',
        labels: []
      }
    }
  },
  mounted () {
    this.previewBox.width = this.$refs.previewBox.clientWidth
    this.onDragReview(this.reviewBox.posX / this.previewRatio, this.reviewBox.posY / this.previewRatio)
    this.onDragStar(this.starRating.posX / this.previewRatio, this.starRating.posY / this.previewRatio)
    this.onDragLogo(this.footer.marginX / this.previewRatio, this.footer.marginBottom / this.previewRatio)

    this.useBg()

    window.events.$on('navigateTowardsRoute', (routeTowards) => {
      this.isFormChanged = false
      this.$router.push(routeTowards)
    })

    window.events.$on('custom-dd-changed', (data) => {
      if (data.group === 'adsCreatorFontSize') {
        this.formVal.fontSize = data.value
      }

      if (data.group === 'adsCreatorAction' && data.changedByHuman) {
        if (data.value === 'download') {
          this.saveAndDownloadAd()
        } else if (data.value === 'publish') {
          this.isSaving = true

          let promise = new Promise((resolve, reject) => {
            this.saveToLibrary(resolve)
          })

          promise.then(data => {
            let promise = new Promise((resolve, reject) => {
              this.publishAd(data.imageUrl, this.formVal.channel, resolve)
            })
            promise.then(() => {
              this.$router.go()
            })
          })
        }
      }
    })

    window.events.$on('custom-tab-js-changed', (data) => {
      if (data.group === 'adsLibraryBgPopup') {
        if (data.tabId === 'standard') {
          this.bgModal.disableDelete = true
          if (!this.bgModal.standard.filter.page.current) {
            this.fetchStandardBg()
          }
        } else {
          this.bgModal.disableDelete = false
          if (!this.bgModal.custom.filter.page.current) {
            this.fetchUploadedBg()
          }
        }
      }
    })

    if ('permalink' in this.$route.query) {
      const filters = JSON.parse(JSON.stringify(this.reviewPayload))
      filters.permalink = this.$route.query.permalink
      axios.get(`/business/${this.businessSlug}/reviews`, {
        params: {
          filters,
          sort: {
            by: 'created_at',
            order: 'desc'
          },
          paging: {
            start: 0,
            count: 1
          }
        }
      })
        .then(({data}) => {
          const review = data.data.reviews[0]._source
          this.chooseReview({
            authorDisplayName: review.authorDisplayName,
            review_body: review.review_body,
            rating: review.rating
          })
        })
    }
  },
  /**
   * Event before navigating to desired route
   * @param {object} to Route where user want to navigate
   * @param {object} from Route where is coming from navigation
   * @param {function} next Navigating towards the intended route if true
   * @return {void}
   */
  beforeRouteLeave (to, from, next) {
    // If user changed the form and is Enterprise/Pro user
    if (this.isFormChanged) {
      this.pageLeaveModal.to_path = to.path
      // Fire off confirmation modal
      modal(this.pageLeaveModal)
    } else {
      window.events.$off('navigateTowardsRoute')
      window.events.$off('custom-dd-changed')
      window.events.$off('custom-tab-js-changed')
      next()
    }
  },
  computed: {
    previewRatio () {
      if (this.previewBox.width && this.formVal.channel) {
        return this.channels[this.formVal.channel].width / this.previewBox.width
      }
      return 1
    },
    previewBoxHeight () {
      if (this.previewRatio && this.formVal.channel) {
        return this.channels[this.formVal.channel].height / this.previewRatio
      }
      return 1
    },

    reviewTextXPos () {
      return this.previewBox.reviewTextPos.x * this.previewRatio
    },
    reviewTextYPos () {
      return this.previewBox.reviewTextPos.y * this.previewRatio
    },
    starXPos () {
      return this.previewBox.starPos.x * this.previewRatio
    },
    starYPos () {
      return this.previewBox.starPos.y * this.previewRatio
    },
    logoXPos () {
      return this.previewBox.logoPos.x * this.previewRatio
    },
    logoYPos () {
      return this.previewBox.logoPos.y * this.previewRatio
    },

    reviewForPreview () {
      if (this.formVal.review.body) {
        return {
          author: this.formVal.review.author,
          body: this.formVal.review.selectedBody,
          rating: this.formVal.review.rating
        }
      }

      return {
        author: 'John Allen',
        body: 'Best service !',
        rating: 3
      }
    },
    reviewPayload () {
      return {
        string: this.reviewModal.filter.keyword,
        date: {
          start: this.reviewModal.filter.dateFilter.startDate,
          end: this.reviewModal.filter.dateFilter.endDate
        },
        channel: ['HELLOPETER'],
        status: [],
        rating: this.reviewModal.filter.starRating
      }
    },
    canFetchReviewList () {
      return (
        this.isPaidUser &&
        !this.reviewModal.isLoading &&
        this.reviewModal.filter.page.current <
        this.reviewModal.filter.page.total
      )
    },

    canFetchStandardImages () {
      return (
        this.isPaidUser &&
        !this.bgModal.standard.isLoading &&
        this.bgModal.standard.filter.page.current <
        this.bgModal.standard.filter.page.total
      )
    },
    canFetchUploadedImages () {
      return (
        this.isPaidUser &&
        !this.bgModal.custom.isLoading &&
        this.bgModal.custom.filter.page.current <
        this.bgModal.custom.filter.page.total
      )
    }
  },
  methods: {
    openImageLibraryModal () {
      this.imageLibraryModal.show = true
    },
    unselectBizLogo () {
      this.formVal.bizLogo.url = ''
      this.formVal.bizLogo.dataUri = ''
    },
    handleBizLogoChosen (logo) {
      this.formVal.bizLogo.url = logo.data.imageForlderUrl + logo.data.fileName
      // this.formVal.bizLogo.url = "https://s3-us-west-2.amazonaws.com/hp-cdn-01/uploads/image-library/mail/uploaded/biON499gANaxUuxPfTPq1pnpjiHTsmJzzcpi99cl.jpeg"
      // this.formVal.bizLogo.url = "https://s3-us-west-2.amazonaws.com/hp-cdn-01/uploads/image-library/mail/uploaded/9R7mIU5KCHrjv4ggaYf3lFgIcu1LtEQVkbk7Jvug.png"

      axios.get(`/helper/image-to-uri?imageUrl=${this.formVal.bizLogo.url}`)
        .then(({data}) => {
          this.formVal.bizLogo.dataUri = data.data.uri
        })

      this.bizLogoSlider.isLoading = true
      const img = new Image()
      img.addEventListener('load', () => {
        const sliderLabels = []
        for (let x = 1; x <= img.naturalWidth; x++) {
          sliderLabels.push({
            label: x.toString(),
            value: x
          })
        }
        this.bizLogoSlider.labels = sliderLabels
        this.bizLogoSlider.default = img.naturalWidth.toString()
        this.formVal.bizLogo.width = img.naturalWidth
        this.bizLogoSlider.isLoading = false
      })
      img.src = this.formVal.bizLogo.url

      this.closeImageLibraryModal()
    },
    closeImageLibraryModal () {
      this.imageLibraryModal.show = false
    },

    openBgModal () {
      this.bgModal.show = true
    },
    unlockStandardScroll () {
      setTimeout(() => {
        this.bgModal.standard.lockScroll = false
      }, 1000)
    },
    handleStandardScroll () {
      if (
        this.$refs.standardBgList.offsetHeight +
        this.$refs.standardBgList.scrollTop >=
        this.$refs.standardBgList.scrollHeight &&
        !this.bgModal.standard.lockScroll
      ) {
        this.bgModal.standard.lockScroll = true
        const scrollTop = this.$refs.standardBgList.scrollTop

        let promise = new Promise((resolve, reject) => {
          this.fetchStandardBg(resolve)
        })
        promise.then(() => {
          this.unlockStandardScroll()
          this.$refs.standardBgList.scrollTop = scrollTop
        })
      }
    },
    fetchStandardBg (resolve = null) {
      if (this.canFetchStandardImages) {
        this.bgModal.standard.isLoading = true

        if (!this.bgModal.standard.allData.length) {
          const images = require.context(
            '../../../../static/img/ads/standard_bg/',
            true,
            /.*_thumb\.(png|jpg)$/
          )
          this.bgModal.standard.allData = images.keys()
          this.bgModal.standard.filter.page.total = this.bgModal.standard.allData.length
        }

        const data = this.bgModal.standard.allData.slice(
          this.bgModal.standard.filter.page.current,
          this.bgModal.standard.filter.page.current + 25
        )
        this.bgModal.standard.filter.page.current += 25

        this.bgModal.standard.listData.push(...data)
        this.bgModal.standard.isLoading = false
        if (resolve) {
          resolve()
        }
      } else if (resolve) {
        resolve()
      }
    },
    unlockUploadedScroll () {
      setTimeout(() => {
        this.bgModal.custom.lockScroll = false
      }, 1000)
    },
    handleUploadedScroll () {
      if (
        this.$refs.uploadedBgList.offsetHeight +
        this.$refs.uploadedBgList.scrollTop >=
        this.$refs.uploadedBgList.scrollHeight &&
        !this.bgModal.custom.lockScroll
      ) {
        this.bgModal.custom.lockScroll = true
        const scrollTop = this.$refs.uploadedBgList.scrollTop

        let promise = new Promise((resolve, reject) => {
          this.fetchUploadedBg(resolve)
        })
        promise.then(() => {
          this.unlockUploadedScroll()
          this.$refs.uploadedBgList.scrollTop = scrollTop
        })
      }
    },
    fetchUploadedBg (resolve = null) {
      if (this.canFetchUploadedImages) {
        this.bgModal.custom.isLoading = true

        const payload = {page: ++this.bgModal.custom.filter.page.current}
        axios
          .get(`/business/${this.businessSlug}/ads/images`, {
            params: payload
          })
          .then(({data}) => {
            this.bgModal.custom.listData.push(...data.data.data)
            this.bgModal.custom.filter.page.total = data.data.last_page
            this.bgModal.custom.isLoading = false

            if (resolve) {
              resolve()
            }
          })
      } else if (resolve) {
        resolve()
      }
    },
    uploadImage (file) {
      this.bgModal.custom.isUploading = true

      if (
        ['image/png', 'image/jpeg'].includes(file.type) &&
        file.size >= 200000 && // 200KB
        file.size <= 10000000 // 10MB
      ) {
        const reader = new FileReader()
        reader.onload = () => {
          file.content = reader.result
          axios
            .post(`/business/${this.businessSlug}/ads/images`, {
              file: file.content,
              channel: this.formVal.channel
            })
            .then(() => {
              this.bgModal.custom.isUploading = false

              this.bgModal.custom.filter.page.current = 0
              this.bgModal.custom.filter.page.total = 1
              this.bgModal.custom.listData = []
              this.fetchUploadedBg()
            })
            .catch((error) => {
              this.bgModal.custom.isUploading = false

              this.closeBgModal()
              if (error.response.data.message === 'Validation error') {
                let errors = ''
                for (let field in error.response.data.data) {
                  errors += `<li>${error.response.data.data[field]}</li>`
                }
                flash(errors, 'is-danger')
              } else {
                flash(error.response.data.message, 'is-danger')
              }
            })
        }
        reader.readAsDataURL(file)
      } else {
        this.bgModal.custom.isUploading = false

        this.closeBgModal()
        flash(
          'Upload a PNG or JPEG file. Minimum dimensions as per channel. Max file size is 10 MB.',
          'is-danger'
        )
      }
    },
    selectBg (image, index = -1) {
      if (index === -1 && this.bgModal.selected.url !== image) {
        this.bgModal.selected.index = 0
        this.bgModal.selected.id = 0
        this.bgModal.selected.width = 0
        this.bgModal.selected.height = 0
        this.bgModal.selected.url = image
      } else if (
        index > -1 &&
        this.bgModal.selected.url !== image.image &&
        !this.areDimensionsLess(image.width, image.height)
      ) {
        // Your images section
        this.bgModal.selected.index = index
        this.bgModal.selected.id = image.id
        this.bgModal.selected.url = image.image
        this.bgModal.selected.width = image.width
        this.bgModal.selected.height = image.height
      }
    },
    deleteBg () {
      axios
        .delete(
          `/business/${this.businessSlug}/ads/images/${this.bgModal.selected.id}`
        )
        .then(({data}) => {
          this.bgModal.custom.listData.splice(this.bgModal.selected.index, 1)

          this.bgModal.selected.id = 0
          this.bgModal.selected.url = ''
          this.bgModal.selected.index = 0
        })
    },
    useBg () {
      if (!this.bgModal.selected.id) {
        const image1 = this.bgModal.selected.url.substring(
          0,
          this.bgModal.selected.url.lastIndexOf('_thumb')
        )
        this.formVal.bgImage.url = '/static/img/ads/standard_bg/' + image1 + '.jpg'
      } else {
        this.formVal.bgImage.url = this.bgModal.selected.url
      }
      this.formVal.bgImage.width = this.bgModal.selected.width
      this.formVal.bgImage.height = this.bgModal.selected.height

      this.closeBgModal()

      this.reposition.zoomSlider.prevVal = ''
      this.reposition.cropCanvas.prevVal.x = ''
      this.reposition.cropCanvas.prevVal.y = ''
      if (this.$refs.previewCropper) {
        this.$refs.previewCropper.replace(this.formVal.bgImage.url)
      }
    },
    closeBgModal () {
      this.bgModal.show = false
    },

    openReviewModal () {
      this.reviewModal.filter = {
        dateFilter: {
          label: 'last_6_months',
          endDate: null,
          startDate: null,
          styleProp: {},
          props: [
            {
              name: 'date',
              label: 'Date',
              showApplyBtn: true,
              dataTrack: 'data-track="Social Ads Creator - Image creator tab - Review date filter change',
              default: {
                type: 'months',
                value: 6,
                selected: 'Last 6 months'
              }, // moment.js placeholder in type
              disabled: [],
              elements: [
                'Last 7 days',
                'Previous month',
                'Last 6 months',
                'Last 12 months',
                'Custom'
              ]
            }
          ]
        },
        starRating: [],
        keyword: '',
        page: {
          current: 0,
          total: 1,
          perPage: 7
        }
      }
      this.reviewModal.show = true
    },
    handleReviewDateChange (dateFilter) {
      Object.assign(this.reviewModal.filter.dateFilter, dateFilter)
    },
    handleReviewRatingChange (ratingFilter) {
      let rating = []
      for (let rate of ratingFilter) {
        if (rate) {
          rating.push(rate)
        }
      }

      if (rating.length === 5) {
        rating = []
      }

      this.reviewModal.filter.starRating = rating
    },
    unlockReviewsScroll () {
      setTimeout(() => {
        this.reviewModal.lockScroll = false
      }, 1000)
    },
    handleReviewsScroll () {
      if (
        this.$refs.reviewList.offsetHeight + this.$refs.reviewList.scrollTop >=
        this.$refs.reviewList.scrollHeight &&
        !this.reviewModal.lockScroll
      ) {
        this.reviewModal.lockScroll = true
        const scrollTop = this.$refs.reviewList.scrollTop

        let promise = new Promise((resolve, reject) => {
          this.fetchReviews(resolve)
        })
        promise.then(() => {
          this.unlockReviewsScroll()
          this.$refs.reviewList.scrollTop = scrollTop
        })
      }
    },
    fetchReviews (resolve = null) {
      if (this.canFetchReviewList) {
        this.reviewModal.isLoading = true

        ++this.reviewModal.filter.page.current
        axios.get(`/business/${this.businessSlug}/reviews`, {
          params: {
            filters: JSON.parse(JSON.stringify(this.reviewPayload)),
            sort: {
              by: 'created_at',
              order: 'desc'
            },
            paging: {
              start: (this.reviewModal.filter.page.current * this.reviewModal.filter.page.perPage) - this.reviewModal.filter.page.perPage,
              count: this.reviewModal.filter.page.perPage
            }
          }
        })
          .then(({data}) => {
            this.reviewModal.listData.push(...data.data.reviews)
            this.reviewModal.filter.page.total = Math.ceil(data.data.count / this.reviewModal.filter.page.perPage)
            this.reviewModal.isLoading = false

            if (resolve) {
              resolve()
            } else {
              setTimeout(() => {
                const height = this.$refs.reviewList.parentElement.parentElement.offsetHeight - 20
                this.reviewModal.listElemHeight = height
              }, 0)
            }
          })
      } else if (resolve) {
        resolve()
      }
    },
    isLongReview (desc) {
      return desc.length > 320
    },
    showFullReview (review) {
      this.$set(review, 'showFull', true)
    },
    hideFullReview (review) {
      review.showFull = false
    },
    chooseReview (review) {
      this.formVal.review = {
        author: review.authorDisplayName,
        body: review.review_body,
        rating: review.rating,
        selectedBody: ''
      }
      this.closeReviewModal()
    },
    closeReviewModal () {
      this.reviewModal.show = false
    },

    openRepositionMode () {
      const previewFooter = this.$refs.previewFooter
      this.previewBox.footer.yPos = previewFooter.offsetTop
      this.previewBox.footer.width = previewFooter.offsetWidth

      this.reposition.isModeOn = true
    },
    changeZoomSlider (e) {
      if (e.byHuman) {
        this.setReposCropCanvas(e.value.value, true)
        this.reposition.zoomSlider.prevVal = e.value.value
      }
    },
    fireUpCropper (ref) {
      const getBgImageDimensions = new Promise(resolve => {
        let bgImageWidth = this.formVal.bgImage.width
        let bgImageHeight = this.formVal.bgImage.height
        if (!bgImageWidth) { // Standard images
          // Read from disk to get dimensions
          const img = new Image()
          img.addEventListener('load', () => {
            bgImageWidth = img.naturalWidth
            bgImageHeight = img.naturalHeight
            resolve({width: bgImageWidth, height: bgImageHeight})
          })
          img.src = this.formVal.bgImage.url
        } else { // Your images
          resolve({width: bgImageWidth, height: bgImageHeight})
        }
      })

      getBgImageDimensions.then(bgImageDimensions => {
        // Cropper width will be equal to preview area
        // Cropper height will be in ratio as downloaded ad
        this.setReposCropBox(this.previewBox.width, this.previewBoxHeight, ref)

        let canvasWidth = 0
        let canvasRatio = 0
        if (this.formVal.channel === 'inst_post') {
          // Always scroll on whichever is bigger(width or height)
          // Ideally canvas should be equal to BG image dimensions but at zoom 0 we are scaling down the dimensions making smallest of canvas dimension = cropper respective dimension
          if (bgImageDimensions.width < bgImageDimensions.height) { // Vertical scroll
            canvasWidth = this.previewBox.width
            canvasRatio = bgImageDimensions.height / bgImageDimensions.width
          } else { // Horizontal scroll
            const canvasHeight = this.previewBoxHeight
            canvasRatio = bgImageDimensions.width / bgImageDimensions.height
            canvasWidth = canvasHeight * canvasRatio
            canvasRatio = canvasHeight / canvasWidth
          }
        } else {
          // Always vertical scroll
          // Ideally canvas should be equal to BG image dimensions but at zoom 0 we are scaling down the dimensions making canvas width = cropper width
          canvasWidth = this.previewBox.width
          canvasRatio = bgImageDimensions.height / bgImageDimensions.width
        }
        this.reposition.canvasRatio = canvasRatio

        if (this.reposition.isModeOn) {
          let zoomMaxVal = bgImageDimensions.width
          const cropContainerWidth = (this.$refs[ref].getContainerData()).width
          if (bgImageDimensions.width > cropContainerWidth) {
            zoomMaxVal = cropContainerWidth
          }
          const sliderLabels = []
          for (let x = canvasWidth; x <= zoomMaxVal; x++) {
            sliderLabels.push({
              label: x.toString(),
              value: x
            })
          }
          this.reposition.zoomSlider.labels = sliderLabels
          if (this.reposition.zoomSlider.prevVal) {
            this.reposition.zoomSlider.default = this.reposition.zoomSlider.prevVal.toString()
          } else {
            this.reposition.zoomSlider.default = canvasWidth.toString()
          }

          this.setReposCropCanvas(this.reposition.zoomSlider.default)
        } else {
          this.setReposCropCanvas(canvasWidth, false, ref)
          this.setPreviewImage(ref)
        }
      })
    },
    setReposCropCanvas (canvasWidth, maintainRatio = false, ref = 'reposCropper') {
      const canvasHeight = canvasWidth * this.reposition.canvasRatio

      let top = 0
      let left = 0

      if (!maintainRatio) {
        if (this.reposition.cropCanvas.prevVal.x !== '') {
          left = this.reposition.cropCanvas.prevVal.x
          top = this.reposition.cropCanvas.prevVal.y
        } else {
          const pos = this.calcPosToCentralize(canvasWidth, canvasHeight, ref)
          top = pos.top
          left = pos.left
        }
      } else {
        const canvasData = this.$refs.reposCropper.getCanvasData()
        const cropboxData = this.$refs.reposCropper.getCropBoxData()

        const leftSpace = cropboxData.left - canvasData.left
        const rightSpace = canvasData.width - (leftSpace + cropboxData.width)
        if (!leftSpace && rightSpace) {
          left = canvasData.left
        } else if (leftSpace && !rightSpace) {
          left = canvasData.left - (canvasWidth - canvasData.width)
        } else {
          left = canvasData.left - ((canvasWidth - canvasData.width) / 2)
        }

        const topSpace = cropboxData.top - canvasData.top
        const bottomSpace = canvasData.height - (topSpace + cropboxData.height)
        if (!topSpace && bottomSpace) {
          top = canvasData.top
        } else if (topSpace && !bottomSpace) {
          top = canvasData.top - (canvasHeight - canvasData.height)
        } else {
          top = canvasData.top - ((canvasHeight - canvasData.height) / 2)
        }
      }

      this.$refs[ref].setCanvasData({
        left,
        top,
        width: canvasWidth,
        height: canvasHeight
      })
    },
    setReposCropBox (cropperWidth, cropperHeight, ref) {
      const {top, left} = this.calcPosToCentralize(cropperWidth, cropperHeight, ref)
      this.$refs[ref].setCropBoxData({
        left,
        top,
        width: cropperWidth,
        height: cropperHeight
      })

      this.reposition.cropbox.x = left
      this.reposition.cropbox.y = top
    },
    calcPosToCentralize (objWidth, objHeight, objRef = 'reposCropper') {
      let containerRef
      if (objRef === 'reposCropper') {
        containerRef = 'reposBox'
      } else if (objRef === 'previewCropper') {
        containerRef = 'previewCropperBox'
      }
      const reposBox = this.$refs[containerRef]

      let left = 0
      if (reposBox) {
        left = (reposBox.offsetWidth - objWidth) / 2
      }

      let top = 0
      if (reposBox) {
        top = (reposBox.offsetHeight - objHeight) / 2
      }

      return {top, left}
    },
    setPreviewImage (ref = 'reposCropper') {
      let uri = this.$refs[ref].getCroppedCanvas({
        width: this.previewBox.width,
        height: this.previewBoxHeight,
        imageSmoothingQuality: 'high'
      }).toDataURL()
      this.$set(this.previewBox, 'croppedUri', uri)

      uri = this.$refs[ref].getCroppedCanvas({
        width: this.channels[this.formVal.channel].width,
        height: this.channels[this.formVal.channel].height,
        imageSmoothingQuality: 'high'
      }).toDataURL()
      this.adCroppedUri = uri
    },
    completeReposition () {
      const canvasData = this.$refs.reposCropper.getCanvasData()
      this.reposition.cropCanvas.prevVal.x = canvasData.left
      this.reposition.cropCanvas.prevVal.y = canvasData.top

      this.setPreviewImage()
      this.reposition.isModeOn = false
    },

    setCropperContentAlign (align) {
      this.formVal.textAlign = align
    },
    selectReviewText () {
      setTimeout(() => {
        let text = ''
        if (window.getSelection) {
          text = window.getSelection().toString()
        }
        this.formVal.review.selectedBody = text
      }, 0)
    },
    chooseChannel (channel, byHuman = true) {
      if (this.formVal.channel !== channel) {
        this.formVal.channel = channel

        if (
          byHuman &&
          this.formVal.bgImage.width &&
          this.areDimensionsLess(
            this.formVal.bgImage.width,
            this.formVal.bgImage.height
          )
        ) {
          this.selectBg('./1_simon-migaj-Yui5vfKHuzs-unsplash_thumb.png')
        }
        this.useBg()
      }
    },
    chooseFilter (filter) {
      this.formVal.fillOpacity = filter
    },
    changeBizLogoSlider (e) {
      this.formVal.bizLogo.width = e.value.value
    },

    getStyles (element) {
      if ('heightFix' in element.dataset) {
        element.style.paddingBottom = '10px'
      }

      let styles = ''

      const styleProps = getComputedStyle(element)
      for (let i = 0; i < styleProps.length; i++) {
        let styleVal = styleProps.getPropertyValue(styleProps[i])
        styleVal = styleVal.replaceAll('"', "'")
        styles += styleProps[i] + ':' + styleVal + ';'
      }

      return styles
    },
    loopHtml (element, string) {
      const tag = element.tagName.toLowerCase()
      if (tag === 'img') {
        string.html += `<${tag} style="${this.getStyles(element)}" src="${element.src}" />`
        return
      } else if (element.classList.contains('fas')) {
        string.html += `<${tag} class="${element.className}" style="${this.getStyles(element)}">`
      } else {
        string.html += `<${tag} style="${this.getStyles(element)}">`
      }

      if (element.childNodes.length) {
        for (let child of element.childNodes) {
          if (child.nodeName === '#text') {
            string.html += `${child.nodeValue}`
          } else if (child.nodeName !== '#comment') {
            this.loopHtml(child, string)
          }
        }
      }
      string.html += `</${tag}>`
    },
    saveToLibrary (resolve = null) {
      this.isSaving = true

      let html = {html: ''}
      this.loopHtml(this.$refs.adHtml, html)
      axios.post(`/business/${this.businessSlug}/ads/save`,
        {
          html: html.html,
          width: this.channels[this.formVal.channel].width,
          height: this.channels[this.formVal.channel].height,
          channel: this.formVal.channel
        })
        .then(({data}) => {
          if (resolve) {
            resolve({recordId: data.data.recordId, imageUrl: data.data.imageUrl})
          } else {
            this.$router.go()
          }
        })
        .catch((error) => {
          this.isSaving = false

          if (error.response.data.message === 'Validation error') {
            let errors = ''
            for (let field in error.response.data.data) {
              errors += `<li>${error.response.data.data[field]}</li>`
            }
            flash(errors, 'is-danger')
          } else {
            flash(error.response.data.message, 'is-danger')
          }
        })
    },
    saveAndDownloadAd () {
      this.isSaving = true
      let promise = new Promise((resolve, reject) => {
        this.saveToLibrary(resolve)
      })
      promise.then(data => {
        this.downloadAd(data.recordId, data.imageUrl)
          .then(() => {
            this.$router.go()
          })
      })
    },
    onDragReview (x, y) {
      this.previewBox.reviewTextPos.x = x
      this.previewBox.reviewTextPos.y = y
    },
    onDragStar (x, y) {
      this.previewBox.starPos.x = x
      this.previewBox.starPos.y = y
    },
    onDragLogo (x, y) {
      this.previewBox.logoPos.x = x
      this.previewBox.logoPos.y = y
    },

    areDimensionsLess (width, height) {
      return (
        width < this.channels[this.formVal.channel]['width'] ||
        height < this.channels[this.formVal.channel]['height']
      )
    }
  },
  watch: {
    formVal: {
      handler: function () {
        this.isFormChanged = true
      },
      deep: true
    },
    reviewPayload (newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.reviewModal.filter.page.current = 0
        this.reviewModal.filter.page.total = 1
        this.reviewModal.listData = []
        this.fetchReviews()
      }
    },
    previewBoxHeight () {
      ++this.previewBox.key
    }
  },
  filters: {
    formattedDateAndTime (reviewDate) {
      return moment(reviewDate, 'YYYY-MM-DD HH:mm:ss').format('DD MMMM YYYY')
    }
  }
}
</script>

<style scoped>
@import "./common.css";

.reposition-control-box {
  padding-top: 18px;
  margin-bottom: 32px;
}

.reposition-control-box .control {
  margin-left: 14px;
  margin-right: 16px;
  width: 218px;
}

.reposition-control-box button {
  width: 131px;
}

.reposition-box {
  max-width: 1026px;
  max-height: 810px;
  border: 1px solid rgba(88, 89, 91, 0.32);
  margin: auto;
  overflow: hidden;
}

.head {
  margin-top: 11px;
  margin-bottom: 21px;
}

.section_divider {
  margin-top: 3px;
  margin-bottom: 10px;
}

.photo-row {
  margin-top: 13px;
  font-size: 14px;
}

.photo-row-img {
  vertical-align: middle;
  margin-right: 8px;
}

.review-section {
  margin-bottom: 29px;
}

.review-section .section_divider {
  margin-bottom: 15px;
}

.review-box {
  border: solid 1px rgba(88, 89, 91, 0.32);
  margin-top: 15px;
  padding: 9px 8px 9px 15px;
  margin-bottom: 18px;
}

.review-box-inner {
  height: 117px;
  overflow-y: auto;
  padding-right: 10px;
}

.star-rating {
  width: 111px !important;
  margin-bottom: 12px;
  padding-left: 6px;
}

.review-text {
  padding-left: 9px;
  line-height: 20px;
}

.review-text::selection {
  background-color: rgba(48, 170, 225, 0.1);
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #bcbec0;
  border-radius: 10px;
}

.section__light-text {
  color: #707070;
  margin-bottom: 12px;
}

.verte-container {
  border: solid 1px #707070;
  border-radius: 50%;
  margin-right: 7px;
}

.verte >>> .verte__guide {
  width: 28px;
  height: 28px;
}

.filter-contrast-box {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid rgba(88, 89, 91, 0.32);
  cursor: pointer;
  margin: 0 auto 5px;
}

.filter-contrast-box div {
  background-color: #000;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.filter-contrast-box--sel {
  border: 2px solid #30aae1;
}

.filter-contrast-box--light div {
  opacity: 0.25;
}

.filter-contrast-box--dark div {
  opacity: 0.50;
}

.addBizLogoSec {
  height: 66px;
}

.addBizLogoSec .has-spinner {
  padding-top: 32px;
  margin-left: 55px;
}

.bizlogoWidthSlider {
  margin-left: 13px;
  margin-right: 5px;
}

.bizlogoWidthSlider >>> input[type=range]::-webkit-slider-thumb {
  width: 20px;
  height: 20px;
  margin-top: -6px;
}

.bizlogoWidthSlider >>> input[type=range]::-moz-range-thumb, .bizlogoWidthSlider >>> input[type=range]::-ms-thumb {
  width: 20px;
  height: 20px;
  margin-top: -6px;
}

.font-size-dd {
  width: 68px;
  padding-left: 0;
  margin-right: 40px;
}

.font-size-dd >>> .dropdown-content {
  overflow-y: auto;
  height: 225px;
  border-bottom: 1px solid rgba(88, 89, 91, 0.12);
}

.font-size-dd >>> .dropdown-content > div:last-child .border-bottom-dbdbdb {
  border-bottom: none !important;
}

.align--selected {
  border: 1px solid #30aae1;
}

.star-rating-color {
  font-size: 6.5px;
  margin-left: 16px !important;
}

.star-rating-color >>> li:not(.grey),
.cropper-content-rating >>> li:not(.grey) {
  color: var(--starColor);
}
.cropper-content-rating >>>img {
  height: 18px;
}

.grey-bg {
  background: #58595b;
}

.hollow-btn[disabled] {
  border-color: #cdcbcb;
  color: #cdcbcb;
}

.action-dd {
  max-width: 147px;
  padding-left: 15px;
  margin-right: 0;
}

.action-dd >>> button {
  border-radius: 2px;
  border: 1px solid #1261a0;
  background-color: #1261a0 !important;
  color: #fff !important;
}

.action-dd >>> .button.button-dropdown {
  padding-left: 42px !important;
  padding-top: 10px;
  padding-bottom: 7px;
  height: 35px;
}

.action-dd >>> .button.button-dropdown span {
  font-size: 11px !important;
}

.action-dd >>> button.button-dropdown::after {
  border-color: #fff;
  height: 8px;
  width: 8px;
  margin-top: -5px;
  border-width: 2px;
  right: 9px;
}

.action-dd >>> .label-filters {
  font-size: 11px !important;
  text-align: center;
}

.action-dd >>> .border-bottom-dbdbdb {
  padding: 8px 15px !important;
  border: none !important;
}

.action-dd >>> .is-select-active {
  background-color: #eff0f1;
}

.action-dd >>> .dropdown-menu {
  border: 1px solid rgba(88, 89, 91, 0.32) !important;
  margin-top: 1px;
}

.preview-col {
  width: 542px;
  min-width: 542px;
  padding-left: 16px;
  padding-right: 4px;
  margin-top: 11px;
}

.preview-box {
  background-image: url("/static/img/ads/preview_bg.jpg");
  color: #58595b;
  min-height: 596px;
}

.preview-box-head {
  background: #f7f8f8;
  padding: 20px 21px 21px 23px;
}

.preview-box-head a {
  color: #58595b;
  font-size: 14px;
}

.preview-box-head img {
  padding-right: 11px;
}

.preview-box-main {
  padding: 17px 13px;
}

.drag-elem {
  position: absolute;
  z-index: 1 !important;
  cursor: pointer;
}

.drag-elem-highlight {
  outline: 1px dashed #168eea;
  outline-offset: 5px;
}

.ad-preview-footer_divider {
  margin: 0;
  background-color: #fff;
  opacity: 50%;
}

.cropper-content-rating {
  width: auto !important;
}

.cropper-content-rating >>> li {
  font-size: var(--starSize);
  margin-left: var(--starSpacing);
}

.cropper-content-rating >>> li:first-child {
  margin-left: 0;
}

.form-box {
  border-right: 1px solid #f1f1f1;
  padding-right: 18px;
}

.upgrade-box {
  width: 100%;
  margin-bottom: 19px;
  margin-top: 34px;
}

.upgrade-box .upgrade-box__header {
  padding: 6px 15px 11px 10px;
  color: #3b3c3d;
}

.upgrade-box img {
  padding-top: 2px;
}

/** Start: BG image Modal */
#bgModal .modal-card {
  max-width: 836px;
  height: 762px;
}

#bgModal .modal-card-head {
  padding-top: 12px;
}

#bgModal .modal-close-link {
  right: 23px;
  top: 16px;
}

#bgModal .modal-card-body {
  padding: 0 29px 16px 0;
}

#bgModal >>> .tabs {
  margin-left: 48px;
  margin-right: 20px;
  margin-bottom: 15px;
}

#bgModal .thumbnail-container-standard {
  padding-left: 26px;
  padding-right: 14px;
  overflow: auto;
  height: 553px;
}

.thumbnail {
  width: 127px;
  display: inline-block;
  margin: 0 0 30px 25px;
  cursor: pointer;
}

.thumbnail .frame {
  position: absolute;
  border: 2px solid #30aae1;
  top: -4px;
  bottom: 2px;
  left: -4px;
  right: -4px;
  display: none;
}

.thumbnail img {
  width: 100%;
  height: 95px;
}

.thumbnail-caption {
  font-size: 11px;
  line-height: 9px;
  text-align: center;
  margin-bottom: 7px;
}

.thumbnail--selected {
  margin-top: 4px;
  position: relative;
  cursor: unset;
}

.thumbnail--selected .frame {
  display: block;
}

.thumbnail--disabled {
  opacity: 0.3;
  cursor: unset;
}

#bgModal footer {
  background-color: #fff;
  text-align: right;
  padding-right: 50px;
  padding-bottom: 43px;
}

#bgModal footer button {
  width: 130px;
  height: 35px;
}

#bgModal .solid-btn {
  border-radius: 2px;
  background-color: #1261a0;
  font-size: 11px;
  color: #fff;
  margin-left: 25px;
}

.dropzone-box {
  border: none;
  background-color: rgba(243, 243, 243, 0.4);
  min-height: 92px;
  height: 92px;
  font-size: 12px;
  color: #58595b;
  margin-left: 51px;
  margin-bottom: 19px;
  margin-right: 21px;
}

.vue-dropzone {
  padding-top: 17px;
}

.vue-dropzone >>> .dz-message {
  margin: 0;
}

.thumbnail-container-custom {
  padding-left: 26px;
  padding-right: 14px;
  overflow: auto;
  height: 390px;
}

/** End: BG image Modal */

/** Start: Review Modal */
.review-filter-input input {
  font-size: 14px;
  border-radius: 2px;
  border: solid 1px rgba(88, 89, 91, 0.32);
  background-color: #ffffff;
  color: rgba(88, 89, 91, 0.6);
  height: 35px;
  padding-left: 35px !important;
  width: 398px;
}

.review-filter-input .control.has-icons-left .icon {
  color: rgba(88, 89, 91, 0.32);
  font-size: 14px;
  padding: 7px 2px 0 12px;
}

.review-filter-input input::placeholder {
  color: rgba(88, 89, 91, 0.6);
  font-size: 12px;
}

.rating-dropdown >>> .bar-chart-total-reviews {
  display: none;
}

.reviews-block {
  overflow: auto;
  padding-right: 20px;
}

.review-row {
  border-top: 1px solid rgba(88, 89, 91, 0.32);
  padding: 12px 0 27px 1px;
  cursor: pointer;
}

.w89 {
  width: 89%;
}

.star-rating-review >>> li:first-child {
  margin-left: 0;
}

.silver-text {
  opacity: 0.6;
  font-size: 12px;
}

.reviews-warning {
  border-top: 1px solid rgba(88, 89, 91, 0.32);
  padding-top: 18px;
  margin-right: 26px;
}

.alert-box--warning {
  width: 418px;
}

.review-body {
  overflow: hidden;
  display: block;
}

.review-body-hide {
  max-height: 36px;
}

.ellipses {
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #fff;
  padding-left: 8px;
  padding-right: 17px;
}

/** End: Review Modal */

.star-rating-color >>>img {
  height: 11px;
}
</style>



// WEBPACK FOOTER //
// src/pages/social-integration/social-ads/AdsCreator.vue